import type { InstallOnelinerProvider } from './base.js';
import { BashInstallOneliner } from './lang/bash.js';
import { PowerShellInstallOneliner } from './lang/powershell.js';

/**
 * Registered install-oneliner providers, in display order.
 * To add a new host shell: implement InstallOnelinerProvider in
 * `./lang/<name>.ts` and append an instance here.
 */
export const INSTALL_ONELINERS: readonly InstallOnelinerProvider[] = [
  new BashInstallOneliner(),
  new PowerShellInstallOneliner(),
];

/**
 * Pick the provider whose native-extension list includes the target's
 * extension; falls back to the first registered provider.
 */
export function getRecommendedInstallOneliner(filename: string): InstallOnelinerProvider {
  const lower = filename.toLowerCase();
  for (const provider of INSTALL_ONELINERS) {
    if (provider.nativeExtensions.some(ext => lower.endsWith(ext))) {
      return provider;
    }
  }
  return INSTALL_ONELINERS[0];
}

export function getInstallOnelinerById(id: string): InstallOnelinerProvider | undefined {
  return INSTALL_ONELINERS.find(p => p.id === id);
}
